<section class="oil-spill-legend" aria-label="Oil spill prediction legend">
  <button
    type="button"
    class="legend-header"
    [attr.aria-expanded]="!collapsed"
    aria-label="Toggle oil spill prediction legend"
    (click)="toggleLegend()"
  >
    <span>Legend</span>
    <span class="material-icons-outlined legend-chevron" [class.legend-chevron--collapsed]="collapsed">
      expand_less
    </span>
  </button>

  <div class="legend-body" *ngIf="!collapsed">
    <section
      class="detection-group"
      *ngFor="let group of groups; trackBy: trackGroup"
    >
      <button
        type="button"
        class="detection-header"
        [attr.aria-expanded]="isExpanded(group)"
        [attr.aria-label]="'Toggle ' + group.label + ' forecasts'"
        (click)="toggleGroup(group)"
      >
        <span class="legend-swatch" [style.background-color]="group.color"></span>
        <span class="detection-name">{{ group.label }}</span>
        <span
          *ngIf="group.forecasts.length"
          class="material-icons-outlined group-chevron"
          [class.group-chevron--collapsed]="!isExpanded(group)"
        >
          expand_less
        </span>
      </button>

      <div class="forecast-row" *ngIf="group.forecasts.length && isExpanded(group)">
        <span class="forecast-label">Forecast</span>
        <div class="forecast-items">
          <span
            class="forecast-item"
            *ngFor="let forecast of group.forecasts; trackBy: trackForecast"
            [attr.title]="'Forecast at +' + forecast.hour + ' hours'"
          >
            <span class="legend-swatch legend-swatch--forecast" [style.background-color]="forecast.color"></span>
            <span>{{ forecast.hour }}h</span>
          </span>
        </div>
      </div>
    </section>

    <div
      class="extra-feed-line"
      *ngFor="let item of extraItems; trackBy: trackExtraItem"
      [ngStyle]="item.style"
    >
      <span
        *ngIf="item.legendColor"
        class="legend-swatch extra-feed-swatch"
        [style.background-color]="item.legendColor"
      ></span>
      <span class="extra-feed-text">
        <b>{{ item.text }}</b>
        <span *ngIf="item.subText" class="extra-feed-subtext">{{ item.subText }}</span>
      </span>
    </div>
  </div>
</section>
